import { Component } from 'opus-angular-seed-core';
import template from './template.html';

@Component({
    bindings: {
        materials: '<',
        selectedLanguage: '<',
        getLabel: '&',
        isLanguageShown: '&',
        onChange: '&'
    },
    template
})
export default class {
    /**
     * Getter and setter of the select: the selection is only reported, the shown value always
     * follows the language the editor has selected.
     */
    language (language) {
        if (language !== undefined) {
            this.onChange({ language });
        }

        return this.selectedLanguage;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/authoringTool/editor/languageSelect/index.js